import { type FC } from 'react';
import { Text } from '@yandex-360/orb-components/dist/components/Text';

import cn from 'classnames';

import css from './Card.module.css';

export enum CardType {
    Link = 'link',
    Common = 'common',
    Accent = 'accent',
    Feature = 'feature'
}

export type CardBackground = 'primary' | 'secondary' | 'white' | 'gray';

export type CardProps = {
    type: CardType;
    icon: string;
    iconForceWidth?: 'small' | 'wide';
    title: string;
    className?: string;
    text?: string;
    align?: 'left' | 'center';
    bg: CardBackground;
};

export const Card: FC<CardProps> = ({
    type,
    className,
    icon,
    title,
    text,
    bg,
    align = 'left',
    iconForceWidth = 'small',
}) => {
    return (
        <div
            className={cn(
                className,
                css.card,
                css[type],
                css[bg],
                css[align])
            }
        >
            <img
                className={ cn(css.icon, css[iconForceWidth]) }
                src={icon}
                alt={title}
                data-test-image={icon}
            />

            <div className={css.bottom}>
                <div className={css.textBlock}>
                    <Text typography='heading-xs' as="h4" className={css.title}>{title}</Text>

                    <Text typography='body-md-regular' as="p" color='secondary' className={css.text}>
                        {text}
                    </Text>
                </div>
            </div>
        </div>
    );
};
